// src/sim/pool.ts -- pure, no DOM
export class Pool<T extends { active: boolean }> {
  private items: T[];
  private _activeCount = 0;

  constructor(size: number, factory: () => T) {
    this.items = Array.from({ length: size }, factory);
  }

  get activeCount(): number {
    return this._activeCount;
  }

  acquire(): T | null {
    for (const item of this.items) {
      if (!item.active) {
        item.active = true;
        this._activeCount++;
        return item;
      }
    }
    return null; // pool exhausted -- no allocation
  }

  release(item: T): void {
    item.active = false;
    this._activeCount--;
  }

  forEach(fn: (item: T) => void): void {
    for (const item of this.items) {
      if (item.active) fn(item);
    }
  }
}
